import TumengRuler from './src/index.vue'

TumengRuler.install = function(Vue) {
  Vue.component(TumengRuler.name, TumengRuler)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengRuler)
}

export default TumengRuler
